let menuItem = [
  {
    url: '/doctor/notice-board',
    name: 'Dashboard',
    icon: 'MonitorIcon',
    slug: 'dashboard',
    i18n: 'Notice Board',
  },
  ...['NZ', 'AU'].includes(process.env.VUE_APP_REGION) ? [
    {
      url: '/doctor/shop',
      name: 'Shop',
      icon: 'ShoppingBagIcon',
      slug: 'shop',
      permission:'Shop',
      i18n: 'Products',
    },
    {
      url: '/doctor/orders',
      name: 'My Orders',
      slug: 'orders',
      i18n: 'My Orders',
      permission:'Shop',
      icon: 'TruckIcon',
    },
    {
      url: '/nurse/dispense-request',
      name: 'Dispense Request',
      icon: 'ListIcon',
      slug: 'dispense-request',
      i18n: 'Dispense Request',
      permission: 'Shop',
    },
    {
      url: '/doctor/patients',
      name: 'Patient Management',
      icon: 'FolderPlusIcon',
      slug: 'patients',
      i18n: 'Patients',
    },
    {
      url: '/doctor/invoices',
      name: 'Invoice Management',
      slug: 'invoice',
      i18n: 'Invoices',
      icon: 'DollarSignIcon',
      permission: 'Invoice',
    },
    {
      url: '/doctor/events',
      name: 'Training & Events',
      icon: 'CalendarIcon',
      slug: 'events',
      i18n: 'Training & Events',
    },
    {
      url: '/doctor/referral',
      name: 'Refer Someone to Fresh',
      slug: 'referral',
      i18n: 'Refer Someone to Fresh',
      icon: 'UserPlusIcon',
    },
    {
      header: 'Resource Hub',
      i18n: 'Resource Hub',
      items: [
        {
          url: '/doctor/resources',
          name: 'Resources',
          icon: 'CodepenIcon',
          slug: 'resources',
          i18n: 'Resources',
        },
      ],
    },
    {
      header: 'Compliance',
      permission: 'Compliance',
      i18n: 'Compliance',
      items: [
        {
          url: '/doctor/drugbook',
          name: 'Drugbook',
          icon: 'BookIcon',
          slug: 'drugbook',
          i18n: 'Drugbook',
          permission:'Drug',
        },
        {
          url: '/doctor/inventory',
          name: 'Inventory',
          featherIcon: false,
          icon: 'kitchen',
          slug: 'inventory',
          i18n: 'Inventory',
          permission: 'Drug',
        },
        {
          url: '/doctor/compliance',
          name: 'Compliance',
          icon: 'GridIcon',
          slug: 'compliance',
          i18n: 'Compliance Checks',
          permission:'Compliance',
        },
      ],
    },
  ] : [
    {
      url: '/doctor/patients',
      name: 'Patient Management',
      icon: 'FolderPlusIcon',
      slug: 'patients',
      i18n: 'Patients',
    },
    {
      url: '/doctor/events',
      name: 'Training & Events',
      icon: 'CalendarIcon',
      slug: 'events',
      i18n: 'Training & Events',
    },
    {
      url: '/doctor/referral',
      name: 'Refer Someone to Fresh',
      slug: 'referral',
      i18n: 'Refer Someone to Fresh',
      icon: 'UserPlusIcon',
    },
    {
      url: '/doctor/resources',
      name: 'Resources',
      icon: 'CodepenIcon',
      slug: 'resources',
      i18n: 'Resources',
    },
    {
      url: '/doctor/invoices',
      name: 'Invoice Management',
      slug: 'invoice',
      i18n: 'Invoices',
      icon: 'DollarSignIcon',
      permission:'Invoice',
    },
    {
      url: '/doctor/drugbook/entries',
      name: 'Drugbook',
      icon: 'BookIcon',
      slug: 'drugbook',
      i18n: 'Drugbook',
      permission:'Drug',
    },
    {
      url: '/doctor/inventory',
      name: 'Inventory',
      featherIcon: false,
      icon: 'kitchen',
      slug: 'inventory',
      i18n: 'Inventory',
      permission: 'Drug',
    },
    {
      url: '/doctor/compliance',
      name: 'Compliance',
      icon: 'GridIcon',
      slug: 'compliance',
      i18n: 'Compliance Checks',
      permission:'Compliance',
    },
    {
      url: '/doctor/shop',
      name: 'Shop',
      icon: 'ShoppingBagIcon',
      slug: 'shop',
      permission:'Shop',
      i18n: 'Shop',
    },
    {
      url: '/doctor/orders',
      name: 'My Orders',
      slug: 'orders',
      i18n: 'My Orders',
      permission:'Shop',
      icon: 'TruckIcon',
    },
    {
      url: '/doctor/consent-forms',
      name: 'Consent Forms',
      icon: 'ActivityIcon',
      slug: 'consent-forms',
      i18n: 'Consent Forms',
      permission: 'CustomConsentForm',
    },
  ],
  {
    header: 'Settings',
    icon: 'SettingsIcon',
    i18n: 'Settings',
    permission:'Settings',
    items: [
      {
        url: '/doctor/clinics',
        name: 'Clinics',
        icon: 'HomeIcon',
        slug: 'clinics',
        i18n: 'Clinics',
      },
      {
        url: '/doctor/staff',
        name: 'Staff',
        icon: 'UsersIcon',
        slug: 'staff',
        i18n: 'Staff',
      },
      ...['NZ', 'AU'].includes(process.env.VUE_APP_REGION) ? [
        {
          url: '/doctor/consent-forms',
          name: 'Consent Forms',
          icon: 'ActivityIcon',
          slug: 'consent-forms',
          i18n: 'Consent Forms',
          permission: 'CustomConsentForm',
        },
      ] : [],
      {
        url: '/doctor/settings/products-list',
        name: 'doctor Products List',
        slug: 'doctor-products-list',
        icon: 'CheckSquareIcon',
        i18n: 'Products List',
      },
      {
        url: '/doctor/settings/custom-products-list',
        name: 'doctor Custom Products List',
        slug: 'doctor-custom-products-list',
        icon: 'CheckSquareIcon',
        i18n: 'Products List',
        permission: 'CustomProduct',
      },
      {
        url: '/doctor/settings/treatment-areas',
        name: 'doctor Treatment Areas',
        slug: 'doctor-treatment-areas',
        icon: 'ShuffleIcon',
        i18n: 'Treatment Areas',
      },
    ],
  },
];

export default menuItem;
